enum ChatEventType {
  CHANNEL_OPENED = 'chn:o'
}

export default ChatEventType;